/**
 * Links Hide — Product Page JS
 * File: assets/lh-product.js
 *
 * Handles:
 * 1. Waitlist form submission to Klaviyo
 *
 * Configuration:
 * - Set KLAVIYO_PUBLIC_KEY to your Klaviyo public API key (found in Klaviyo → Account → API Keys)
 * - Set KLAVIYO_LIST_ID to the ID of your "Waitlist" list in Klaviyo
 *   (found in Klaviyo → Lists → select your list → the ID is in the URL)
 *
 * Setup steps:
 * 1. In Klaviyo, create a list called "Links Hide Waitlist"
 * 2. Copy the list ID from the URL (e.g. "ABC123")
 * 3. Copy your public API key from Account → API Keys
 * 4. Replace the placeholder values below
 */

(function () {
  'use strict';

  // ─── Configuration ────────────────────────────────────────────────────────
  const KLAVIYO_PUBLIC_KEY = 'W6gg5w';
  const KLAVIYO_LIST_ID    = 'U2SRrB';
  // ──────────────────────────────────────────────────────────────────────────

  /**
   * Subscribe an email address to a Klaviyo list.
   * Uses Klaviyo's client-side API v2 — safe to call from the frontend
   * because it only uses the public API key.
   */
  async function subscribeToKlaviyo(email) {
    const endpoint = `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_PUBLIC_KEY}`;

const payload = {
  data: {
    type: 'subscription',
    attributes: {
      custom_source: 'Links Hide Waitlist Form',
      profile: {
        data: {
          type: 'profile',
          attributes: {
            email: email
          }
        }
      }
    },
    relationships: {
      list: {
        data: {
          type: 'list',
          id: KLAVIYO_LIST_ID
        }
      }
    }
  }
};

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-02-15'
      },
      body: JSON.stringify(payload)
    });

    // Klaviyo returns 202 Accepted on success
    if (!response.ok && response.status !== 202) {
      throw new Error(`Klaviyo subscription failed: ${response.status}`);
    }

    return true;
  }

  /**
   * Initialise the inline waitlist form on the product page.
   */
  function initWaitlistForm() {
    const form      = document.getElementById('lh-waitlist-form');
    const emailInput = document.getElementById('lh-waitlist-email');
    const submitBtn  = document.getElementById('lh-waitlist-submit');
    const successMsg = document.getElementById('lh-waitlist-success');
    const fieldsWrap = document.getElementById('lh-waitlist-fields');

    if (!form || !emailInput || !submitBtn) return;

    submitBtn.addEventListener('click', async function () {
      const email = emailInput.value.trim();

      if (!email || !isValidEmail(email)) {
        emailInput.focus();
        emailInput.style.borderColor = 'var(--lh-brass)';
        return;
      }

      // Disable button during request
      submitBtn.disabled = true;
      submitBtn.textContent = '...';

      try {
        await subscribeToKlaviyo(email);

        // Hide the form, show success
        fieldsWrap.style.display = 'none';
        successMsg.classList.add('is-visible');

      } catch (error) {
        console.error('Waitlist signup error:', error);
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify me';
        // Soft failure — don't show a scary error to the customer
        // Consider adding error state styling here if needed
      }
    });

    // Reset border color on input focus
    emailInput.addEventListener('focus', function () {
      emailInput.style.borderColor = '';
    });
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWaitlistForm);
  } else {
    initWaitlistForm();
  }

})();
